export { Size } from 'choerodon-ui/lib/_util/enum';
export var ViewMode;
(function (ViewMode) {
    ViewMode["kanban"] = "kanban";
    ViewMode["card"] = "card";
    ViewMode["table"] = "table";
})(ViewMode || (ViewMode = {}));
export var ViewModeIcon;
(function (ViewModeIcon) {
    ViewModeIcon["kanban"] = "kanban";
    ViewModeIcon["card"] = "kapian";
    ViewModeIcon["table"] = "biaoge-o";
})(ViewModeIcon || (ViewModeIcon = {}));
export var ViewField;
(function (ViewField) {
    ViewField["activeKey"] = "defaultFlag";
    ViewField["viewProps"] = "dataJson";
    ViewField["viewMode"] = "viewType";
    ViewField["viewName"] = "viewName";
    ViewField["id"] = "id";
    ViewField["groupField"] = "groupField";
    ViewField["cardWidth"] = "cardWidth";
    ViewField["displayFields"] = "displayFields";
    ViewField["showLabel"] = "showLabel";
    ViewField["sort"] = "sort";
    ViewField["viewHeight"] = "viewHeight";
    ViewField["combineSort"] = "combineSort";
})(ViewField || (ViewField = {}));
